import { render, staticRenderFns } from "./progressLoading.vue?vue&type=template&id=fbfa1ac8&scoped=true&"
import script from "./progressLoading.vue?vue&type=script&lang=js&"
export * from "./progressLoading.vue?vue&type=script&lang=js&"
import style0 from "./progressLoading.vue?vue&type=style&index=0&id=fbfa1ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa1ac8",
  null
  
)

export default component.exports